/**
 * theme.js — テーマ初期化（セクション登録・グローバル UI）
 *
 * JS 読み込み順（変更禁止）:
 *   theme-helpers.js → theme-utils.js → theme-ui.js →
 *   theme-product.js → theme-sections.js → theme.js → custom.js
 *
 * ストア固有の上書き・追加は custom.js へ。
 */
(function (Theme) {
  'use strict';

  var _classCallCheck = Theme._classCallCheck;
  var _defineProperties = Theme._defineProperties;
  var _createClass = Theme._createClass;
  var _defineProperty = Theme._defineProperty;
  var _inherits = Theme._inherits;
  var _getPrototypeOf = Theme._getPrototypeOf;
  var _setPrototypeOf = Theme._setPrototypeOf;
  var _isNativeReflectConstruct = Theme._isNativeReflectConstruct;
  var _construct = Theme._construct;
  var _isNativeFunction = Theme._isNativeFunction;
  var _wrapNativeSuper = Theme._wrapNativeSuper;
  var _assertThisInitialized = Theme._assertThisInitialized;
  var _possibleConstructorReturn = Theme._possibleConstructorReturn;
  var _createSuper = Theme._createSuper;

  var Responsive = Theme.Responsive;
  var Animation = Theme.Animation;
  var Dom = Theme.Dom;
  var Accessibility = Theme.Accessibility;
  var Image = Theme.Image;
  var Currency = Theme.Currency;
  var carousel = Theme.carousel;
  var collapsible = Theme.collapsible;
  var drawer = Theme.drawer;
  var LoadingBar = Theme.LoadingBar;
  var modal = Theme.modal;
  var popover = Theme.popover;
  var PageTransition = Theme.PageTransition;
  var SearchBar = Theme.SearchBar;
  var CountrySelector = Theme.CountrySelector;
  var OverflowScroller = Theme.OverflowScroller;
  var PriceRange = Theme.PriceRange;
  var ScrollSpy = Theme.ScrollSpy;
  var ProductItemColorSwatch = Theme.ProductItemColorSwatch;
  var ProductImageZoom = Theme.ProductImageZoom;
  var ProductModel = Theme.ProductModel;
  var ProductReviews = Theme.ProductReviews;
  var form = Theme.form;
  var VariantSelector = Theme.VariantSelector;
  var StoreAvailability = Theme.StoreAvailability;
  var ProductVariants = Theme.ProductVariants;
  var ProductVideo = Theme.ProductVideo;
  var ShippingEstimator = Theme.ShippingEstimator;
  var AddressesSection = Theme.AddressesSection;
  var ArticleListSection = Theme.ArticleListSection;
  var ArticleSection = Theme.ArticleSection;
  var CartSection = Theme.CartSection;
  var CollectionListSection = Theme.CollectionListSection;
  var CollectionSection = Theme.CollectionSection;
  var FaqSection = Theme.FaqSection;
  var FeaturedCollectionsSection = Theme.FeaturedCollectionsSection;
  var FeaturedProductSection = Theme.FeaturedProductSection;
  var VideoHeroSection = Theme.VideoHeroSection;
  var GiftCardSection = Theme.GiftCardSection;
  var HeaderSection = Theme.HeaderSection;
  var FooterSection = Theme.FooterSection;
  var ImageTextBlockSection = Theme.ImageTextBlockSection;
  var LoginSection = Theme.LoginSection;
  var MapSection = Theme.MapSection;
  var NewsletterPopupSection = Theme.NewsletterPopupSection;
  var ProductRecommendationsSection = Theme.ProductRecommendationsSection;
  var ProductSection = Theme.ProductSection;
  var RecentlyViewedSection = Theme.RecentlyViewedSection;
  var SectionRegistry = Theme.SectionRegistry;
  var FeaturedCollectionCarouselSection = Theme.FeaturedCollectionCarouselSection;
  var ProductHotspotSection = Theme.ProductHotspotSection;
  var ContentShowcaseSection = Theme.ContentShowcaseSection;
  var NavigationDrawerSection = Theme.NavigationDrawerSection;
  var SlideshowSection = Theme.SlideshowSection;
  var TestimonialsSection = Theme.TestimonialsSection;
  var TimelineSection = Theme.TimelineSection;

  // ---------------------------------------------------------------------------
  // 初期化 — グローバル UI と sectionRegistry.registerSection()
  // data-theme-section 属性で各 Section クラスと紐付け
  // ---------------------------------------------------------------------------
  (function () {

    new collapsible();
    new modal();
    new Responsive();

    if (window.theme.pageType !== 'password' && window.theme.pageType !== 'gift_card') {
      new LoadingBar();
    }

    var sectionRegistry = new SectionRegistry();

    var sectionsToRegister = [
      ['header', HeaderSection],
      ['footer', FooterSection],
      ['navigation-drawer', NavigationDrawerSection],
      ['cart', CartSection],
      ['newsletter-popup', NewsletterPopupSection],
      ['slideshow', SlideshowSection],
      ['collection-list', CollectionListSection],
      ['article-list', ArticleListSection],
      ['featured-product', FeaturedProductSection],
      ['image-with-text-block', ImageTextBlockSection],
      ['map', MapSection],
      ['featured-collections', FeaturedCollectionsSection],
      ['product-hotspot', ProductHotspotSection],
      ['content-showcase', ContentShowcaseSection],
      ['testimonials', TestimonialsSection],
      ['video-hero', VideoHeroSection],
      ['product', ProductSection],
      ['product-recommendations', ProductRecommendationsSection],
      ['collection', CollectionSection],
      ['article', ArticleSection],
      ['faq', FaqSection],
      ['login', LoginSection],
      ['addresses', AddressesSection],
      ['gift-card', GiftCardSection],
      ['recently-viewed-products', RecentlyViewedSection],
      ['featured-collection-carousel', FeaturedCollectionCarouselSection]
    ];

    sectionsToRegister.forEach(function (entry) {
      try {
        sectionRegistry.registerSection(entry[0], entry[1]);
      } catch (error) {
        console.error('[theme] Failed to register section "' + entry[0] + '":', error);
      }
    });
    

    try {
      if (window.flickity && window.flickity.defaults) {
        window.flickity.defaults.dragThreshold = 7;
      }
    } catch (error) {
      console.error('[theme] Flickity defaults:', error);
    }

    (function () {
      var touchingCarousel = false,
          touchStartCoords;
      document.body.addEventListener('touchstart', function (e) {
        if (e.target.closest('.flickity-slider')) {
          touchingCarousel = true;
        } else {
          touchingCarousel = false;
          return;
        }

        touchStartCoords = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        };
      });
      document.body.addEventListener('touchmove', function (e) {
        if (!(touchingCarousel && e.cancelable)) {
          return;
        }

        var moveVector = {
          x: e.touches[0].pageX - touchStartCoords.x,
          y: e.touches[0].pageY - touchStartCoords.y
        };
        if (Math.abs(moveVector.x) > flickity.defaults.dragThreshold) e.preventDefault();
      }, {
        passive: false
      });
    })();
    

    (function () {
      if (window.flickity) {
        var originalResizeMethod = window.flickity.prototype.resize,
            lastWidth = window.innerWidth;

        window.flickity.prototype.resize = function () {
          if (window.innerWidth === lastWidth && this.maxCellHeight > 0) {
            return;
          }

          lastWidth = window.innerWidth;
          originalResizeMethod.apply(this, arguments); 
        };
      }
    })();
    

    (function () {
      
      Dom.nodeListToArray(document.querySelectorAll('.rte table')).forEach(function (table) {
        table.outerHTML = '<div class="table-wrapper">' + table.outerHTML + '</div>';
      });
      Dom.nodeListToArray(document.querySelectorAll('.rte iframe')).forEach(function (iframe) {
        
        if (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1 || iframe.src.indexOf('vimeo') !== -1) {
          iframe.outerHTML = '<div class="video-wrapper">' + iframe.outerHTML + '</div>'; 
          

          iframe.src = iframe.src;
        }
      });
    })();
    

    (function () {
      var documentDelegate = new domDelegate.Delegate(document.body),
          announcementBar = document.querySelector('.announcement-bar');
      documentDelegate.on('click', '[href^="#"], [data-href]', function (event, target) {
        var selector = target.hasAttribute('href') ? target.getAttribute('href') : target.getAttribute('data-href');

        if (selector === '#' || selector === '#main') {
          return;
        }

        var element = document.querySelector(selector),
            offset = parseInt(target.getAttribute('data-offset') || 0);

        if (announcementBar) {
          offset -= announcementBar.clientHeight;
        }

        if (target.hasAttribute('data-focus-on-click')) {
          var prevScrollY = window.pageYOffset;
          element.focus({
            preventScroll: true
          }); 

          if (window.pageYOffset !== prevScrollY) {
            window.scrollTo(window.pageXOffset, prevScrollY);
          }

          element.focus();
        }

        window.scrollTo({
          behavior: 'smooth',
          top: element.offsetTop - offset
        });
        event.preventDefault();
      });
    })();

    (function () {
      var windowWidth = window.innerWidth,
          headerSection = document.getElementById('shopify-section-header');
      window.addEventListener('resize', function () {
        var newWidth = -1;
        fastdom.measure(function () {
          newWidth = window.innerWidth;
        });
        fastdom.mutate(function () {
          if (newWidth === windowWidth) {
            return;
          }

          windowWidth = newWidth;
          document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');

          if (headerSection) {
            document.documentElement.style.setProperty('--header-height', headerSection.clientHeight + 'px');
          }
        });
      });
    })();

    (function () {
      function handleFirstTab(event) {
        if (event.keyCode === 9) {
          document.body.classList.add('is-tabbing');
          window.removeEventListener('keydown', handleFirstTab);
        }
      }

      window.addEventListener('keydown', handleFirstTab);
    })();
    

    if (window.theme.enablePageFade) {
      PageTransition.getInstance();
    }
  })();

})(window.SammyTheme);
